import { useTranslation } from '@thoughtspot/i18n';
import React, { forwardRef } from 'react';
import { Input } from '../input';
const DatePickerInput = ({ hasError, placeholderText, ...restProps }, _ref) => {
    const { t } = useTranslation();
    return (React.createElement(Input.Text, { "aria-label": t('Input.DATE_INPUT_ARIA'), "data-testid": "date-select-input", hasError: hasError, ...restProps, placeholder: placeholderText }));
};
export default forwardRef(DatePickerInput);
//# sourceMappingURL=date-picker-input.js.map